<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active"><a href="/event">Event</a></li>
      <li v-if="$route.params.id" class="breadcrumb-item">
        <a :href="'/event/' + $route.params.id">{{ event.name }}</a>
      </li>
      <li v-if="breadcrumbNew" class="breadcrumb-item">
        <a :href="'/event/new'">New</a>
      </li>
      <li v-if="breadcrumbEdit" class="breadcrumb-item">
        <a :href="'/event/' + $route.params.id + '/edit'">Edit</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Events <small></small></h1>
    <!-- end page-header -->
    <router-view
      v-bind:events="events"
      v-bind:event="event"
      v-bind:activeEvent="activeEvent"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { imageService } from '../services/image.service.js'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'Event',
  data() {
    return {
      breadcrumb: '',
      breadcrumbNew: false,
      breadcrumbEdit: false
    }
  },
  computed: {
    ...mapState('event', ['events', 'event', 'activeEvent'])
  },
  methods: {
    ...mapActions('event', [
      'getEvents',
      'getEvent',
      'createEvent',
      'copyEvent',
      'updateEvent',
      'deleteEvent',
      'setActiveEvent'
    ]),
    create(eventData) {
      this.createEvent(eventData)
    },
    copy(eventId, eventData) {
      this.copyEvent({ eventId, eventData })
    },
    update(eventId, eventData) {
      this.updateEvent({ eventId, eventData })
      this.$router.push('/event/' + this.event.id)
      this.getEvent(this.$route.params.id)
    },
    delete(eventId) {
      this.deleteEvent(eventId)
      this.$router.push('/event')
    },
    setActive(event) {
      this.setActiveEvent(event)
      this.$router.push('/')
    },
    removeImage(imageId) {
      imageService.deleteImage(imageId)
    },
    updateBreadcrumbs() {
      if (this.$route.path.includes('new')) {
        this.breadcrumbNew = true
      } else if (this.$route.path.includes('edit')) {
        this.breadcrumbEdit = true
      }
    }
  },
  created() {
    PageOptions.pageWithoutSidebar = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageWithoutSidebar = false
    next()
  },
  mounted() {
    this.updateBreadcrumbs()
    this.getEvents()
    if (this.$route.params.id) {
      this.getEvent(this.$route.params.id)
    }
    if (!this.activeEvent) {
      this.setActiveEvent(this.events[0])
    }
  },
  watch: {
    $route() {
      this.updateBreadcrumbs()
    }
  }
}
</script>
